module.exports = __webpack_public_path__ + "static/img/mm_logo_small.aadd308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mm_logo_small.png
// module id = zO2a
// module chunks = 0